import { render, staticRenderFns } from "./SettingUpdate.vue?vue&type=template&id=063c7a40&scoped=true"
import script from "./SettingUpdate.vue?vue&type=script&lang=js"
export * from "./SettingUpdate.vue?vue&type=script&lang=js"
import style0 from "./SettingUpdate.vue?vue&type=style&index=0&id=063c7a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c7a40",
  null
  
)

export default component.exports